import React, { useContext, useEffect, useState } from "react";
import {Params, useParams} from "react-router";
import { Panel } from "../../components/Panel";
import PartnerDisplayForm from "../../components/PartnerDisplayForm";
import IconComponent from "../../components/IconComponent";
import {ModelPartnerPartner} from "@dia-ui/util_interlink-api";
import { Alert } from "../../components/Alert";
import {AppContext, AppContextType} from "../../context/AppContext";
import {RouteItem} from "../../routes";
import {getBreadcrumb, setBreadcrumb} from "../../components/Breadcrumb";

export function PartnerDisplay() {
  const {
    services: {
      servicePartnerPartner
    },
    I18N,
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * parameters
   */
  const { id, type } = useParams<{ id: string; type: string }>(),
    [partner, setPartner] = useState<ModelPartnerPartner | undefined>(undefined),
    [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPartner = async () => {
      try {
        if (id) {
          const _partner: ModelPartnerPartner = await servicePartnerPartner.getById(id);
          setPartner(_partner);
        }
      } catch (error) {
        console.error(I18N.t("Error fetching partner data:"), error);
        setError(I18N.t("Fehler beim Abrufen der Partnerdaten. Bitte versuchen Sie es später erneut."));
      }
    };

    fetchPartner();
  }, [id, servicePartnerPartner, I18N]);

  /**
   * partnerData
   */
  const partnerData = partner && type ? partner[type] : undefined,
    logoUrl = partnerData?.hashId ? servicePartnerPartner.getCompanyLogoUrl(partnerData.hashId) : null;

  return (
    <>
      { error && <Alert message={error} /> }
      <Panel
        header={
        <dia-grid-nested data-grid-nested-full-width>
          <dia-grid-row data-grid-column-stretch>
            <dia-grid-column>
              <IconComponent iconName={ ROUTE_CONFIG.PARTNER_VIEW_EDIT.icon } />
              <span style={{ marginLeft: "8px" }}>
               { getBreadcrumb("PARTNER_VIEW_EDIT") }
              </span>
            </dia-grid-column>
            { logoUrl && (
              <dia-grid-column>
                <img
                  src={ logoUrl }
                  alt={`${ partnerData?.name || I18N.t("Logo") } Logo`}
                  style={{
                    maxWidth: "100px",
                    maxHeight: "50px",
                    minWidth: "100px",
                    minHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </dia-grid-column>
            ) }
          </dia-grid-row>
        </dia-grid-nested>
        }
      >
        {partner && type && <PartnerDisplayForm partner={partner} type={type} />}
      </Panel>
    </>
  );
}

/**
 * PartnerLoader
 * @param context
 * @param id
 * @constructor
 */
function PartnerPartnerLoader(context: AppContextType, id: string): Promise<ModelPartnerPartner> {
  return context.services.servicePartnerPartner.getById(id);
}

/**
 * PartnerDisplayBreadcrumb
 * @param route
 * @param context
 * @param params
 * @constructor
 */
export function PartnerDisplayBreadcrumb(route: RouteItem, context: AppContextType, params: Params<string>): string | undefined {
  (async () => {
    if (!params.id || !params.type) return;

    const partnerPartner: ModelPartnerPartner = await PartnerPartnerLoader(context, params.id);
    if (partnerPartner[params.type]?.name) {
      setBreadcrumb("PARTNER_VIEW_EDIT", partnerPartner[params.type].name, "append");
    }
  })();

  return route.title;
}
